import { types as t } from 'mobx-state-tree';
import { SpeechCorrectionModel as SpeechCorrectionModelType } from '../utils/assessment-type';

export const SpeechCorrectionModel = t.custom<any, SpeechCorrectionModelType>({
  name: 'SpeechCorrectionModel',
  fromSnapshot(value: any) {
    return value;
  },
  toSnapshot(value: any) {
    return value;
  },
  isTargetType(): boolean {
    return true;
  },
  getValidationMessage(): string {
    return ''; // bypass for now
  },
});
